export const ACTIVE_CLUB_CONTENT_REFETCH_INTERVAL_MS = 60_000;

// Keep club/paywall descriptions fresh in an already-open session without changing
// app-wide query defaults or polling while the page is backgrounded.
export const activeClubContentFreshnessOptions = {
  staleTime: 0,
  refetchInterval: ACTIVE_CLUB_CONTENT_REFETCH_INTERVAL_MS,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: true,
  refetchOnReconnect: true,
} as const;
